import React, { useEffect } from "react";
import DatePickerMulti from 'react-multi-date-picker'
import Button from 'react-multi-date-picker/components/button'
import { BiCalendarAlt, BiCheck, BiHash, BiX } from 'react-icons/bi'
import { BsChevronDown } from 'react-icons/bs'
import moment from 'moment'
import { Alert } from 'reactstrap'
import { IoCalendarClear } from 'react-icons/io5'
import { toastContainer, dismissToast } from "../../../utils/toast";


export default function MultirangeDatePickerDesigned({
  dateRange,
  handleDateChange,
  noAlert,
  headingText = 'Insights',
  user
}) {

  
  useEffect(() => {
    return () => dismissToast(); // <-- Correct usage of cleanup in useEffect
  }, []);
  if (noAlert) {
    return (
      <div>
        <DatePickerMulti
          value={dateRange}
          onChange={handleDateChange}
          range
          render={
            <Button
              className={
                dateRange && dateRange.length > 1
                  ? 'trivia-results-datepicker-added-dates'
                  : 'trivia_survey_datepicker_button'
              }
              children={
                dateRange && dateRange.length == 0 ? (
                  <React.Fragment>
                    <BiCalendarAlt className="mr-2" /> All Time{' '}
                    <BsChevronDown className="ml-5" />{' '}
                  </React.Fragment>
                ) : (
                  <span>
                    {' '}
                    {moment(dateRange[0]).format('MMMM D, YYYY')} -{' '}
                    {moment(dateRange[1]).format('MMMM D, YYYY')}{' '}
                    <span className="trivia-results-datepicker-added-dates-rightcross">
                      <BiX size={22} onClick={() => handleDateChange([])} />
                    </span>
                  </span>
                )
              }
            />
          }
        />
      </div>
    )
  }

  return (
    <div style={{ width: "500px" }}>
      <Alert className="d-flex align-items-center text-center" color="primary">
        <h5
          style={{ fontWeight: "bolder", marginBottom: "0px", color: "black" }}
        >
          {headingText} as of{" "}
        </h5>
        <div
          className="ml-4 dp-w-manage"
          style={{ flex: 1, position: "relative" }}
        >
          {user && user.role === "Admin" ? (
            <DatePickerMulti
              value={dateRange}
              onChange={handleDateChange}
              range
              style={{ height: "40px", width: "100%" }}
              format="MM/DD/YYYY"
            />
          ) : (
            <h5
              style={{
                fontWeight: "bolder",
                marginBottom: "0px",
                color: "black",
              }}
            >
              {dateRange.length > 0
                ? moment(dateRange[0]).format("MMMM D, YYYY")
                : "No Date Selected"}
            </h5>
          )}

          {/* <IoCalendarClear
            size={22}
            className="calendar-icon"
            style={{
              position: "absolute",
              right: "30px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              }}
          /> */}
        </div>
        {user && (

          <Button
          onClick={() => {
            const url = new URL(window.location.href);
            
            // Replace '/edit/' with '/public/' in the pathname
            url.pathname = url.pathname.replace("/edit/", "/public/");

            // Add or update 'orgId' param
            url.searchParams.set("orgId", user.organizationId._id);

            navigator.clipboard
              .writeText(url.toString())
              .then(() => {
                toastContainer("Link Copied to Clipboard", "success");
                setTimeout(() => {
                  dismissToast();
                }, 3000);
              })
              .catch((err) => {
                console.error("Failed to copy URL: ", err);
              });
            }}
            >
          Share Results
        </Button>
        )}
      </Alert>
    </div>
  );
}
